import type CustomerPurgeRepository from "@/core/administration/repositories/CustomerPurgeRepository";
import type { CustomerPurgeResult } from "@/core/administration/entities/CustomerPurge";
import { RepositoryResult } from "@/core/shared/types/RepositoryResult";
import { HttpClient } from "../../http/HttpClient";
import { ApiResponse } from "../../api/types/ApiResponse";
import { executeRequest } from "../../http/services/executeRequest/executeRequest";
import customerPurgeEndpoints from "../../api/customerPurgeEndpoints/customerPurgeEndpoints";

type CustomerPurgeResponseDto = {
  businessKey: string;
  deletedRowsByTable: Record<string, number>;
  keycloakIdentityDeleted: boolean;
  minioObjectsAttempted: number;
};

export default class CustomerPurgeRepositoryBackend implements CustomerPurgeRepository {
  constructor(private readonly httpClient: HttpClient) {}

  purge(
    businessKey: string,
    password: string,
  ): Promise<RepositoryResult<CustomerPurgeResult>> {
    return executeRequest(
      () =>
        this.httpClient.post<ApiResponse<CustomerPurgeResponseDto>, { password: string }>({
          url: customerPurgeEndpoints.confirm(businessKey),
          body: { password },
          withAuth: true,
        }),
      (dto) => ({
        businessKey: dto.businessKey,
        deletedRowsByTable: dto.deletedRowsByTable,
        keycloakIdentityDeleted: dto.keycloakIdentityDeleted,
        minioObjectsAttempted: dto.minioObjectsAttempted,
      }),
    );
  }
}
